__turbopack_context__.v({
  "apple": "PlasmicFooterTopDownload-module__FvgTxq__apple",
  "apple3": "PlasmicFooterTopDownload-module__FvgTxq__apple3",
  "appstore": "PlasmicFooterTopDownload-module__FvgTxq__appstore",
  "desktop": "PlasmicFooterTopDownload-module__FvgTxq__desktop",
  "download": "PlasmicFooterTopDownload-module__FvgTxq__download",
  "download3": "PlasmicFooterTopDownload-module__FvgTxq__download3",
  "footerTopDownload": "PlasmicFooterTopDownload-module__FvgTxq__footerTopDownload",
  "mobileTablet": "PlasmicFooterTopDownload-module__FvgTxq__mobileTablet",
  "play": "PlasmicFooterTopDownload-module__FvgTxq__play",
  "play2": "PlasmicFooterTopDownload-module__FvgTxq__play2",
  "play6": "PlasmicFooterTopDownload-module__FvgTxq__play6",
  "play7": "PlasmicFooterTopDownload-module__FvgTxq__play7",
  "pngegg1": "PlasmicFooterTopDownload-module__FvgTxq__pngegg1",
  "pngegg2": "PlasmicFooterTopDownload-module__FvgTxq__pngegg2",
  "pngegg5": "PlasmicFooterTopDownload-module__FvgTxq__pngegg5",
  "qr1": "PlasmicFooterTopDownload-module__FvgTxq__qr1",
  "qr2": "PlasmicFooterTopDownload-module__FvgTxq__qr2",
  "row2": "PlasmicFooterTopDownload-module__FvgTxq__row2",
  "row6": "PlasmicFooterTopDownload-module__FvgTxq__row6",
});
